import { createContext } from "react";
import { Article } from "@/features/search/types/search";
export interface NewsletterConfig {
  topics: string[];
  topicsEmbedding?: number[]; // Vector embedding for topics
  tone?:
    | "Friendly"
    | "Focus on the technical side"
    | "Just bullet points pls"
    | "Make my own"
    | null;
  toneFeedback: string;
  frequency: "daily" | "weekly" | "biweekly" | "monthly" | null;
  preferredDay?: string;
  testEmail: string;
  currentStep: number;
  isActive: boolean;
}

// Separate interface for preview state
export interface NewsletterPreview {
  subject: string;
  body: string;
  articles: Article[];
}

export interface NewsletterContextType {
  config: NewsletterConfig;
  preview: NewsletterPreview | null;
  updateTopics: (topics: string[]) => void;
  updateTone: (tone: NewsletterConfig["tone"], feedback: string) => void;
  updateFrequency: (params: {
    frequency: NewsletterConfig["frequency"];
    preferredDay?: string;
    email?: string;
  }) => void;
  updatePreview: (preview: NewsletterPreview | null) => void;
  updateIsActive: (isActive: boolean) => void;
  isStepValid: (step: number) => boolean;
}

const defaultContext: NewsletterContextType = {
  config: {
    topics: [],
    tone: null,
    toneFeedback: "",
    frequency: null,
    preferredDay: "",
    testEmail: "",
    currentStep: 1,
    isActive: true,
  },
  preview: null, // Separated from config
  updateTopics: () => {},
  updateTone: () => {},
  updateFrequency: () => {},
  updatePreview: () => {}, // Renamed for clarity
  updateIsActive: () => {},
  isStepValid: () => false,
};

export const NewsletterContext =
  createContext<NewsletterContextType>(defaultContext);
